import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmDialog.module.scss'

interface IProps {
  open: boolean
  handleOpen: () => void
  handleConfirm: () => void
  dialogTitle: string
  dialogMessage: string
  children?: any;
  dialogMessageFontSize?: number;
  dialogMessageColor?: string;
}

export const ConfirmDialog = (props: IProps) => {
  const { open, handleOpen, dialogTitle, dialogMessage, handleConfirm, children, dialogMessageFontSize = 16, dialogMessageColor = 'gray' } = props

  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={handleOpen}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText color={dialogMessageColor} fontSize={dialogMessageFontSize}>{dialogMessage}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpen} className={styles.cancelButton}>
          {t('Cancel')}
        </Button>
        <Button onClick={handleConfirm} className={styles.confirmButton}>
          {t('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
